import React from 'react'
import { useGlobalCtx } from '../../../Context/GlobalContext'

const ARCSFooter = React.lazy(() => import('../../../Themes/arcs/markup/footer'));
const DisneyFooter = React.lazy(() => import('../../../Themes/disney/markup/footer'));
const MMRCICFooter = React.lazy(() => import('../../../Themes/mmr-cic/markup/footer'));
const MMRMARSFooter = React.lazy(() => import('../../../Themes/mmr-mars/markup/footer'));
const BlinkFooter = React.lazy(() => import('../../../Themes/insightspace/markup/footer'));
const BethesdaFooter = React.lazy(() => import('../../../Themes/bethesda/markup/footer'));
const ParadoxFooter = React.lazy(() => import('../../../Themes/paradox/markup/footer'));
const UofPennFooter = React.lazy(() => import('../../../Themes/penn/markup/footer'));
const ActivisionFooter = React.lazy(() => import('../../../Themes/activision/markup/footer'));
const VerizonFooter = React.lazy(() => import('../../../Themes/verizon/markup/footer'));
const EAFooter = React.lazy(() => import('../../../Themes/ea/markup/footer'));
const BlizzardFooter = React.lazy(() => import('../../../Themes/blizzard/markup/footer'));
const BungieFooter = React.lazy(() => import('../../../Themes/bungie/markup/footer'));
const KingFooter = React.lazy(() => import('../../../Themes/king/markup/footer'));
const KynetecFooter = React.lazy(() => import('../../../Themes/kynetec/markup/footer'));
const OpinlyFooter = React.lazy(() => import('../../../Themes/opinly/markup/footer'));
const SpencerFooter = React.lazy(() => import('../../../Themes/spencer/markup/footer'));
const BurtsBeesFooter = React.lazy(() => import('../../../Themes/burtsbees/markup/footer'));
const GreatLakesFooter = React.lazy(() => import('../../../Themes/greatlakes/markup/footer'));
const BHVRFooter = React.lazy(() => import('../../../Themes/bhvr/markup/footer'));
const BootsFooter = React.lazy(() => import('../../../Themes/boots/markup/footer'));
const No7Footer = React.lazy(() => import('../../../Themes/no7/markup/footer'));
const NRGFooter = React.lazy(() => import('../../../Themes/nrg/markup/footer'));
const CRGFooter = React.lazy(() => import('../../../Themes/crg/markup/footer'));
const PinPointFooter = React.lazy(() => import('../../../Themes/pinpoint/markup/footer'));
const InsightsCentersFooter = React.lazy(() => import('../../../Themes/insightscenters/markup/footer'));
const BrightsideFooter = React.lazy(() => import('../../../Themes/brightside/markup/footer'));
const BrightsideVoicesFooter = React.lazy(() => import('../../../Themes/brightside-voices/markup/footer'));
const NoThemeFooter = React.lazy(() => import('../../../Themes/notheme/markup/footer'));
const BlinkuxFooter = React.lazy(() => import('../../../Themes/blinkux/markup/footer'));
const CustomFooter = React.lazy(() => import('../../../Themes/custom/markup/footer'));

//const DynamicFooter = React.lazy(() => import('../../../Themes/markup/footer'))
const TbsoFooter = React.lazy(() => import('../../../Themes/tbso/markup/footer'));
const PupFooter = React.lazy(() => import('../../../Themes/pup/markup/footer'));
export default function Footer(props: any) {
  const globalCtx = useGlobalCtx();
  let component = null;
  switch (globalCtx.Theme.toLocaleLowerCase()) {
    case "arcs":
      component = <ARCSFooter />;
      break;
    case "paradox":
      component = <ParadoxFooter />;
      break;
    case "penn":
      component = <UofPennFooter />;
      break;
    case "bethesda":
      component = <BethesdaFooter />;
      break;
    case "activision":
      component = <ActivisionFooter />;
      break;
    case "mmr-cic":
      component = <MMRCICFooter />;
      break;
    case "mmr-mars":
      component = <MMRMARSFooter />;
      break;
    case "nrg":
      component = <NRGFooter />;
      break;
    case "crg":
      component = <CRGFooter />;
      break;
    case "disney":
      component = <DisneyFooter />;
      break;
    case "blink":
    case 'insightspace':
      component = <BlinkFooter />;
      break;
    case "ea":
    case 'ea-cte':
      component = <EAFooter />;
      break;
    case "verizon":
      component = <VerizonFooter />;
      break;
    case "blizzard":
      component = <BlizzardFooter />;
      break;
    case "bungie":
      component = <BungieFooter />;
      break;
    case "king":
      component = <KingFooter />;
      break;
    case "kynetec":
      component = <KynetecFooter />;
      break;
    case "opinly":
      component = <OpinlyFooter />;
      break;
    case "spencer":
      component = <SpencerFooter />;
      break;
    case "burtsbees":
      component = <BurtsBeesFooter />;
      break;
    case "greatlakes":
      component = <GreatLakesFooter />;
      break;
    case 'behaviourinteractive':
    case 'bhvr':
      component = <BHVRFooter />;
      break;
    case 'boots':
    case 'boots-uk':
      component = <BootsFooter />;
      break;
    case 'no7':
    case 'boots-us':
      component = <No7Footer />;
      break;
    case "pinpoint":
      component = <PinPointFooter />;
      break;
    case "insightscenters":
      component = <InsightsCentersFooter />;
      break;
    case "brightside":
      component = <BrightsideFooter />;
      break;
    case "brightside-voices":
      component = <BrightsideVoicesFooter />;
      break;
    case "notheme":
      component = <NoThemeFooter />;
      break;
    case 'blinkux':
      component = <BlinkuxFooter />;
      break;
    case 'tbso':
      component = <TbsoFooter />;
      break;
    case 'pup':
      component = <PupFooter />;
      break;
    default:
      if (globalCtx.isResourcesLoaded)
        component = <CustomFooter />;
  }
  return (
    <>
      {(globalCtx.StudyId > 0 || globalCtx.StudyIdentifier !== '') && globalCtx.LangResources === null ? (<></>) :
        (
          <React.Suspense>
            {component}
          </React.Suspense>

        )}
    </>
  )
}
